import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import '@/app/App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectIntegration, setIntegration } from '@/store/slices/ReportsSlice'
import { selectLanguage } from '@/api/rtk/userSelectors'
import Layout from '@/app/Layout';
import { setNavigate } from '@/features/auth/lib/authSession';
import { SidebarProvider } from '@/shared/ui/sidebar'
import { store } from '@/store/Store'
import { useTranslation } from 'react-i18next';
import AppRoutes, { AUTH_PATHS } from '@/app/AppRoutes';
import { useReportStatusSocket } from '@/app/hooks/useReportStatusSocket';
import { useEnsureUser } from '@/shared/hooks/useEnsureUser';

const App = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const language = useSelector(selectLanguage)
  const userId = localStorage.getItem('user_id') || "";
  const notIncludesAuthRoutes = !AUTH_PATHS.includes(location.pathname);

  useEnsureUser({ forceFetch: !!userId && notIncludesAuthRoutes });
  useReportStatusSocket(!!userId);

  const integration = useSelector(selectIntegration);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  useEffect(() => {
    if (integration.exists && integration.path !== location.pathname) {
      dispatch(setIntegration('reset'));
    }
  }, [dispatch, integration, location.pathname]);

  useEffect(() => {
    setNavigate(navigate, store);
  }, [navigate]);

  useEffect(() => {
    window.Intercom("update");
  }, [location]);

  useEffect(() => {
    if (!userId) {
      notIncludesAuthRoutes && navigate('/');
    }
  }, [navigate, userId, notIncludesAuthRoutes]);

  return (
    <SidebarProvider>
      <Layout>
        <AppRoutes />
      </Layout>
    </SidebarProvider>
  );
};

export default App;
